/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var getMrbaValidFields = require('../../mrba-dashboard/util/getMrbaValidFields');
var GetMrbasByEntity = require('../services/GetMrbasByEntity');
var DepEntityMrbaSectionView = require('../views/DepEntityMrbaSectionView');

module.exports = {
  channel: 'dp',

  event: 'build:mrba-section-view',

  builder: function(entityId) {
    return new PlaceholderView({
      viewPromise: buildMrbaSectionView(entityId)
    });
  }
};

function buildMrbaSectionView(entityId) {
  var deferred = $.Deferred();
  $.when(GetEntityIdentifiers(entityId), GetMrbasByEntity(entityId))
    .done(function(entityIdentifiers, mrbas) {
      deferred.resolve(
        new DepEntityMrbaSectionView({
          collection: new PageableCollection(mrbas, { pageSize: 25 }),
          model: new Backbone.Model({
            entityMrbas: mrbas,
            validFields: getMrbaValidFields(entityIdentifiers.categoryId),
            entityIdentifiers: entityIdentifiers
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
